export default {
  add_products: '+ Aggiungi prodotti',
};
